import React, { Component, Fragment } from 'react';
import { translate } from 'react-i18next';
import LocalStorage from 'utils/LocalStorage';
import Utils from 'utils/Utils';

import './Header.css';

declare var CONFIGURATIONS;

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      langSelected: LocalStorage.getString('language') || 'es',
    };
  }

  changeLanguage = (lang) => {
    this.setState({ langSelected: lang }, () => {
      LocalStorage.putString('language', lang);
      window.location.reload();
    });
  }

  goMap = () => {
    const url = '/fototeca/visor';
    window.location.href = Utils._sanitizeUrl(url);
  }

  render() {
    const { langSelected } = this.state;

    return (<Fragment>
      <header className='h-desktop'>
        <div className='logo-ign'>
          <img src={CONFIGURATIONS.logo_junta} alt='Logo' />
        </div>
        <div className='logo'>
          <img src={CONFIGURATIONS.logo_ieca} alt='Logo' />
        </div>
        <div className='visor-title' onClick={this.goMap}>
          <label className='title'>{CONFIGURATIONS[`title_${langSelected}`]}</label>
          <label className='subtitle'>{CONFIGURATIONS[`subtitle_${langSelected}`]}</label>
        </div>
        <div className='visor-language'>
          <span className={langSelected === 'es' ? 'lang-selected' : 'lang-option'} onClick={this.changeLanguage.bind(null, 'es')}>es</span>
          <span className={langSelected === 'en' ? 'lang-selected' : 'lang-option'} onClick={this.changeLanguage.bind(null, 'en')}>en</span>
        </div>
      </header>
    </Fragment>);
  }
}

export default translate()(Header);
